'use client';

import React, { useEffect, useState } from 'react';
import { Drawer, Box, Typography, Stack, CircularProgress, IconButton, Button } from '@mui/material';
import { Delete } from '@mui/icons-material';
import axiosClient from '../../api/axiosClient';

interface Advantage {
  id?: number;
  type: string;
  yearlyLimit: number;
  version?: number;
}

interface Category {
  id: number;
  name: string;
  status: string;
  isStandard: boolean;
  version: number;
  createdAt: string;
  updatedAt: string;
  advantages: Advantage[];
}

interface ViewCategoryDrawerProps {
  open: boolean;
  onClose: () => void;
  categoryId: string;
}

export default function ViewCategoryDrawer({ open, onClose, categoryId }: ViewCategoryDrawerProps) {
  const [category, setCategory] = useState<Category | null>(null);
  const [loading, setLoading] = useState(false);
  const [deleting, setDeleting] = useState(false);

 
  useEffect(() => {
    if (!categoryId) return;

    const fetchCategory = async () => {
      setLoading(true);
      try {
        const res = await axiosClient.get(`/categories/${categoryId}`);
        setCategory(res.data.category);
      } catch (err) {
        console.error('Erreur fetch category:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchCategory();
  }, [categoryId]);

 

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box p={3} width={400}>
        <Typography variant="h6" mb={2} color="#714291">
          Category Details
        </Typography>

        {loading ? (
          <Stack alignItems="center" my={4}><CircularProgress /></Stack>
        ) : category ? (
          <>
            <Typography variant="subtitle1"><strong>Name:</strong> {category.name}</Typography>
            <Typography variant="subtitle1"><strong>Status:</strong> {category.status}</Typography>
            <Typography variant="subtitle1"><strong>Standard:</strong> {category.isStandard ? 'Yes' : 'No'}</Typography>
            <Typography variant="subtitle1"><strong>Created At:</strong> {new Date(category.createdAt).toLocaleString()}</Typography>
            <Typography variant="subtitle1"><strong>Updated At:</strong> {new Date(category.updatedAt).toLocaleString()}</Typography>

            <Typography variant="subtitle1" mt={2}><strong>Advantages:</strong></Typography>
            <ul>
              {category.advantages.map((adv) => (
                <li key={adv.id || adv.type}>{adv.type} – {adv.yearlyLimit}€</li>
              ))}
            </ul>

          </>
        ) : (
          <Typography>Aucune donnée trouvée</Typography>
        )}
      </Box>
    </Drawer>
  );
}
